import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  returnTo: z.string().optional(),
});

export const Route = createFileRoute('/$locale/auth/authorize')({
  validateSearch: searchSchema,
});
